import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/authentication.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
    loading = false;
    submitted = false;
    returnUrl!: string;
    message!:string;
    currentYear: number = new Date().getFullYear();

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService:AuthenticationService,
        private spinner: NgxSpinnerService) {}

    ngOnInit() {
      let url = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
      // Basic open redirect prevention: ensure the URL is a local path
      if (url && url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/\\')) {
        this.returnUrl = url;
      } else {
        this.returnUrl = '/dashboard';
      }
      
      if (this.authenticationService.isLoggedIn()) {
        this.router.navigateByUrl(this.returnUrl);
      }
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
      this.submitted = true; 
      this.message=""
      this.spinner.show();
        this.submitted = true;
        let credentials=this.loginForm.value;
        if (this.loginForm.invalid) {
          this.spinner.hide();
            return;

        }
        this.loading = true;
        this.authenticationService.userLogin(credentials).subscribe((res:any)=>{
          this.authenticationService.setToken(res.token);

          this.authenticationService.setUserId(res.id);
          this.authenticationService.setUserFullName(res.name);
          this.authenticationService.setUserLocationId(res.locationId);

          this.authenticationService.saveRefreshToken(res.refreshToken);

          this.authenticationService.setUserName(res.username);
          this.authenticationService.setUserType(res.roles[0]);
          this.spinner.hide();
          this.router.navigateByUrl(this.returnUrl);
        },
        err=>{
          this.spinner.hide()
          console.log("in error login",err)
          if(err=="invalid credentials"){
          this.message="Username or password is incorrect"
          }
        
          this.authenticationService.logout()
        })

    }
}

